import { BaseApi } from "../base";

export default class WebsiteApi extends BaseApi {
  protected readonly prefix = "website";

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
  fetch = (type: any) => this.get(type);
}
